import React from 'react'
import { createRoot } from 'react-dom/client'
import '../stylesheets/index.less'
import App from "./App";

export function init(props = {}) {

  const container = document.getElementById('root')
  const root = container.__root ?? (container.__root = createRoot(container))
  root.render(<App />)
}

window.addEventListener("hashchange", (event) => {
  if (window.location.hash==="#version") {
    console.log(GITVERSION, GITCOMMITDATETIME);
  }
})

init()
